'use client';

import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

const CanadaTerms = (): JSX.Element => {
  const t = useTranslations();

  return (
    <>
      <TypographyV3 Element="h3" variant="h3">
        {t('terms_and_conditions_canada_header')}
      </TypographyV3>
      <TypographyV3>DDP – Delivered Duty Paid</TypographyV3>
      <TypographyV3>{t('terms_of_delivery_canada_description')}</TypographyV3>
      <TypographyV3 Element="h3" variant="h3">
        {t('terms_of_delivery_dap_heading')}
      </TypographyV3>
    </>
  );
};

export default CanadaTerms;
